module.exports = __webpack_public_path__ + "img/矩形.d346974e.png";